export interface Notification {
  id: string;
  message: string;
  hideAutomatically?: boolean;
  time?: number;
  messageType?: NotificationType;
}
export const notifications = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
} as const;

export type NotificationType =
  (typeof notifications)[keyof typeof notifications];
